import { DocumentTextIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../shared/utility";
import Button from "../ui/Button";

export default function ReportsDropdown(props) {
  const {
    actionCall,
    reportComponents,
    showReports,
    setShowReports,
    title,
    reportInProgress,
    triggerVariant = "primary",
  } = props;

  return (
    <div className="relative block">
      <Button
        type="button"
        variant={triggerVariant}
        size="md"
        onClick={() => setShowReports(true)}
      >
        <DocumentTextIcon className="h-5 w-5" aria-hidden="true" />
        {title ? title : "Reports"}
      </Button>

      <div
        className={classNames(
          showReports ? null : "hidden",
          "absolute right-0 z-50 mt-2 w-[min(24rem,calc(100vw-2rem))] origin-top-right overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white shadow-xl focus:outline-none",
        )}
      >
        <div className="flex items-center justify-between border-b border-[#E2E8F0] bg-[#F6F8FB] px-4 py-3">
          <div>
            <p className="text-sm font-semibold text-[#0F172A]">
              {title ? title : "Reports"}
            </p>
            <p className="text-xs text-[#64748B]">
              Choose the report you want to generate.
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShowReports(false)}
            className="rounded-full p-1.5 text-[#64748B] transition hover:bg-white hover:text-[#0F172A]"
            aria-label="Close reports"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="max-h-[65vh] divide-y divide-[#E2E8F0] overflow-y-auto">
          {reportComponents.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </div>

        <div className="flex justify-end gap-2 border-t border-[#E2E8F0] bg-white p-3">
          <Button
            type="button"
            variant="secondary"
            onClick={() => setShowReports(false)}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="primary"
            loading={reportInProgress}
            onClick={() => {
              actionCall();
            }}
          >
            Generate
          </Button>
        </div>
      </div>
    </div>
  );
}
